import { BID_NOTICE_MS } from "../../utils/helper/bidNotifications";

/**
 * The bid notification on screen (#238), outside any component: TopNavbar, which receives the push
 * and draws the pop-up, remounts on every page, and a notice must outlive a page change until it
 * expires. One at a time: a new one replaces the one on screen.
 *
 * @type {{notice: object, expiresAt: number}|null}
 */
let current = null;
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener());

/** The notice on screen and when it hides, or null. */
export const readBidNotice = () => current;

/**
 * Listens for changes, for useSyncExternalStore.
 *
 * @param {() => void} listener
 * @returns {() => void} Stops listening.
 */
export const subscribeBidNotice = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * Shows a notice in place of any on screen, for BID_NOTICE_MS.
 *
 * @param {object} notice A ReceiveBidNotification payload.
 * @param {number} [now] Date.now().
 */
export const showBidNotice = (notice, now = Date.now()) => {
  current = { notice, expiresAt: now + BID_NOTICE_MS };
  emit();
};

/**
 * Gives the notice on screen a full BID_NOTICE_MS again, from when the pointer or focus leaves it.
 *
 * @param {number} [now] Date.now().
 */
export const extendBidNotice = (now = Date.now()) => {
  if (!current) return;
  current = { ...current, expiresAt: now + BID_NOTICE_MS };
  emit();
};

/**
 * Hides the notice: the player dismissed it, followed it, or its time ran out. Closes the pop-up
 * only; the notification stays on the bell and the Notifications page.
 *
 * @param {number} [id] Hide it only if it is still this one, so a timer of a replaced notice does
 *   not hide the new one.
 */
export const dismissBidNotice = (id) => {
  if (!current || (id !== undefined && current.notice?.id !== id)) return;
  current = null;
  emit();
};
